"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBladeViewMinHeight = exports.fixBladePostion = exports.createBladeFlows = exports.createBladeFlowService = exports.FlowService = void 0;
var React = require("react");
var FlowService = /** @class */ (function (_super) {
    __extends(FlowService, _super);
    function FlowService(opt) {
        var _this = _super.call(this, opt) || this;
        var bladeFlows = opt.bladeFlows, _a = opt.scenario, scenario = _a === void 0 ? '' : _a, store = opt.store;
        if (!bladeFlows) {
            return _this;
        }
        _this.blades = bladeFlows["Blades-" + scenario];
        _this.bladeList = bladeFlows["BladeList-" + scenario];
        _this.store = store;
        // build initFormValueState on init
        _this.initFormValueState = _this.getInitialFormValueState();
        return _this;
    }
    FlowService.prototype.getInitialBlade = function () {
        return this.blades[this.bladeList[0]];
    };
    /**
     * getInitialFormValueState
     * @description create initFormValueState from each blade's defaultFormValue
     * populate once for diff comparision purpose.
     * @returns {object | null} this.initFormValueState
     */
    FlowService.prototype.getInitialFormValueState = function () {
        var _a = this, _b = _a.blades, blades = _b === void 0 ? {} : _b, _c = _a.bladeList, bladeList = _c === void 0 ? [] : _c;
        if (this.initFormValueState) {
            return this.initFormValueState;
        }
        var initFormValueState = {};
        bladeList.forEach(function (bladeName) {
            var defaultFormValue = blades[bladeName].defaultFormValue;
            if (defaultFormValue) {
                initFormValueState[bladeName] = defaultFormValue;
            }
        });
        return initFormValueState;
    };
    FlowService.prototype.getNextBlade = function (currentBladeName, currentFormValue) {
        var nextBladeName = this.getNextBladeName(currentBladeName, currentFormValue);
        return this.blades[nextBladeName];
    };
    FlowService.prototype.getNextBladeName = function (currentBladeName, currentFormValue) {
        var nextBladeName = this.getByIndex(currentBladeName);
        nextBladeName = this.checkConditionalBlade(nextBladeName, currentFormValue);
        return nextBladeName;
    };
    FlowService.prototype.getPreviousBlade = function (currentBladeName, currentFormValue) {
        var previouBladeName = this.getPreviousBladeName(currentBladeName, currentFormValue);
        return this.blades[previouBladeName];
    };
    FlowService.prototype.getPreviousBladeName = function (currentBladeName, currentFormValue) {
        var previousBladeName = this.getByIndex(currentBladeName, false);
        previousBladeName = this.checkPreviousConditionalBlade(previousBladeName, currentFormValue);
        return previousBladeName;
    };
    FlowService.prototype.getBladeDisplayName = function (bladeName) {
        return this.blades[bladeName].displayName;
    };
    FlowService.prototype.getByIndex = function (currentBladeName, forward) {
        if (forward === void 0) { forward = true; }
        var currentIndex = this.bladeList.indexOf(currentBladeName);
        if (currentIndex === -1) {
            throw new Error("Blade is not found: " + currentBladeName);
        }
        var targetIndex = forward ? currentIndex + 1 : currentIndex - 1;
        return this.bladeList[targetIndex];
    };
    FlowService.prototype.checkConditionalBlade = function (bladeName, currentFormValue) {
        if (this.shouldSkipBlade(bladeName, currentFormValue)) {
            return this.getNextBladeName(bladeName, currentFormValue);
        }
        return bladeName;
    };
    FlowService.prototype.checkPreviousConditionalBlade = function (bladeName, currentFormValue) {
        if (this.shouldSkipBlade(bladeName, currentFormValue)) {
            return this.getPreviousBladeName(bladeName, currentFormValue);
        }
        return bladeName;
    };
    FlowService.prototype.shouldSkipBlade = function (bladeName, currentFormValue) {
        var conditionFunc = this.blades[bladeName].condition;
        if (conditionFunc) {
            return !conditionFunc(currentFormValue, this.store);
        }
        return false;
    };
    return FlowService;
}(React.Component));
exports.FlowService = FlowService;
/**
 * createBladeFlowService
 * @param {object} opt
 * @description
 * opt.bladeFlows [object] is required - this is the project specific bladeFlow definition
 * opt.scenario [string] - optional
 * opt.store [object] - optional, if conditionFunc in bladeFlows required
 */
function createBladeFlowService(opt) {
    if (opt === void 0) { opt = {}; }
    var bladeFlows = opt.bladeFlows;
    if (bladeFlows) {
        return new FlowService(opt);
    }
    return null;
}
exports.createBladeFlowService = createBladeFlowService;
/**
 * createBladeFlows
 * @param {object} settings
 * @returns {object}
 * @description
 * This is a helper function to generate 'BladeFlows' data structure to be use by FlowService
 * settings.bladeListId [string | number] is required
 * settings.bladesData [array of objects] is required
 * an item should be like the following structure
 * {
 *  name: [string],
 *  component: [React component],
 *  condition: [function(value, store)] - optional
 * }
 *
 */
function createBladeFlows(settings) {
    var _a;
    if (settings === void 0) { settings = {}; }
    var bladeListId = settings.bladeListId, _b = settings.bladesData, bladesData = _b === void 0 ? [] : _b;
    if (typeof bladeListId === 'undefined') {
        return null;
    }
    var bladesSettings = {};
    var bladelist = [];
    bladesData.forEach(function (blade) {
        var bladeName = "" + blade.name;
        if (bladeName !== 'undefined') {
            bladesSettings[bladeName] = __assign({}, blade);
            bladelist.push(bladeName);
        }
    });
    return _a = {},
        _a["Blades-" + bladeListId] = bladesSettings,
        _a["BladeList-" + bladeListId] = bladelist,
        _a;
}
exports.createBladeFlows = createBladeFlows;
/**
 * fixBladePostion
 * @param {object} object - with 'parentNode' and 'bladeNode' properties
 * @param {object} object.parentNode - DOM Node element
 * @param {object} object.bladeNode - DOM Node element
 * @description
 * This helper function is for 'fix' a blade that is using flexbox vertical center
 * when element expand within the blade causing content to move up.
 * It fix the blade by setting inline style to display block and calculate the padding top (distance
 * between the blade container and the blade content).
 */
function fixBladePostion(_a) {
    var parentNode = _a.parentNode, bladeNode = _a.bladeNode;
    if (!parentNode || !bladeNode) {
        return;
    }
    var bladeParentNode = parentNode;
    // delay because ScrollableForm is calling setBladeViewMinHeight to inject stylesheet to browser.
    setTimeout(function () {
        var parentNodeHeight = parentNode.offsetHeight;
        var bladeNodeHeight = bladeNode.offsetHeight;
        var parentTopPadding = (parentNodeHeight - bladeNodeHeight) / 2;
        if (parentTopPadding >= 0) {
            bladeParentNode.style.paddingTop = Math.floor(parentTopPadding) + "px";
        }
        bladeParentNode.style.display = 'block';
    }, 100);
}
exports.fixBladePostion = fixBladePostion;
// cache for Head tag element - so only query once
var headElement;
/*
* Function used to set the min height of the blade view
* by dynamically create a style sheet and inject to document
* So that each blade will occupy the whole screen
*/
function setBladeViewMinHeight(opt) {
    var _a;
    if (opt === void 0) { opt = {}; }
    //  default options
    // footer is querySelector
    var _b = opt.header, header = _b === void 0 ? '#header:not([hidden]), .headerorigination:not([hidden])' : _b, _c = opt.footer, footer = _c === void 0 ? '' : _c, _d = opt.buffer, buffer = _d === void 0 ? 0 : _d, _e = opt.minHeight, minHeight = _e === void 0 ? 200 : _e;
    var headerEl = document.querySelectorAll(header);
    var headerHeight = headerEl.length
        ? headerEl[0].getBoundingClientRect().height
        : 0;
    var footerEl = footer
        ? document.querySelector(footer)
        : null;
    var footerHeight = footerEl
        ? footerEl.getBoundingClientRect().height
        : 0;
    var styleElId = 'blade-view-min-height';
    var style = document.getElementById(styleElId);
    if ((!headerHeight && !footerHeight) || style) {
        return;
    }
    var bladeMinHeight = Math.max(window.innerHeight - (headerHeight + footerHeight + buffer), minHeight);
    var css = ".blade-view { min-height: " + bladeMinHeight + "px }";
    headElement = headElement || document.querySelector('head');
    // Already set - remove it before recreate
    if (style) {
        (_a = document.getElementById(styleElId)) === null || _a === void 0 ? void 0 : _a.remove();
    }
    style = document.createElement('style');
    // @ts-ignore
    style.type = 'text/css';
    style.id = styleElId;
    // @ts-ignore
    if (style.styleSheet) {
        // @ts-ignore
        style.styleSheet.cssText = css;
    }
    else {
        style.appendChild(document.createTextNode(css));
    }
    headElement.appendChild(style);
}
exports.setBladeViewMinHeight = setBladeViewMinHeight;
